// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useRef } from "react";

import Dropdown from "./Dropdown";
import useBoolean from "src/hooks/useBoolean";
import { autoReminderType } from "src/constants/display";
import { Select as StyledSelect, Selection } from "./styles";

type Props = {
  value: number,
  handleChange: (typeId: string) => void,
};

const ReminderTypeSelect = ({ value, handleChange }: Props) => {
  const outerRef = useRef(null);
  const { value: dropdown, toggleBoolean: toggleDropdown } = useBoolean();

  return (
    <StyledSelect ref={outerRef} onClick={toggleDropdown}>
      {dropdown && (
        <Dropdown
          handleClose={toggleDropdown}
          outerRef={outerRef}
          handleChange={handleChange}
        />
      )}

      {value ? (
        <Selection title={autoReminderType[value]}>
          {autoReminderType[value]}
        </Selection>
      ) : (
        <Selection>{i18n.t(k.SELECT_VALUE)}</Selection>
      )}
    </StyledSelect>
  );
};

export default ReminderTypeSelect;
